<rx-intuitive-indication-buttons
	[indicationIds]="indicationIds"
	[selectedIndicationIds]="selectedIndicationIds"
	[enabledIndicationIds]="enabledIndicationIds"
	[disabled]="disabled"
	[hideIcon]="true"
	(indicationSelected)="indicationSelected.emit($event)"
>
	<div class="vertical-separator" aria-hidden="true"></div>
	<rx-intuitive-remove-from-bridge-button (buttonClick)="onRemoveFromBridge()" [disabled]="!canRemove">
	</rx-intuitive-remove-from-bridge-button>
</rx-intuitive-indication-buttons>
